const initialStateHK = {
  // PERSONAL INFORMATION
  firstName: '',
  middleName: '',
  lastName: '',
  dateOfBirth: '',
  gender: '',

  // OCR FILE NAMES
  fileNames: {
    file1: '',
    file2: '',
  },

  // IDENTITY
  nationalIDNo: '',

  // CURRENT RESIDENTIAL ADDRESS
  building: '',
  streetName: '',
  district: '',
  state: '',
  postCode: '',

  // TERMS AND CONDITIONS
  creditBureauConsentObtained: false,

  // REFERENCE NUMBER
  reportingReference: '',

  // ERROR HANDLING
  errors: {},
};

export default initialStateHK;
